import { useCallback, useRef } from 'react';

import { useLayer } from '@coursera-web/statsig';

import { markGuestCheckoutExposed } from 'bundles/payments-common/utils/guestCheckout/guestCheckoutExposure';

/**
 * Statsig layer: https://console.statsig.com/2aQACzHI81tdbY41wEZm3H/layers/consumer-guest-checkout-layer
 *
 * Returns a getter rather than a boolean so callers control when the exposure logs: `useLayer` logs nothing
 * at render, and each `layer.get` call logs an exposure. Call it only at the guest-checkout decision points.
 * Each call also marks the browser as exposed, in either arm, so other checkout experiments can exclude it.
 * The getter's reference is stable across renders and always reads the latest layer.
 */
export const useIsInGuestCheckoutVariant = (): (() => boolean) => {
  const layer = useLayer('consumer-guest-checkout-layer');
  const layerRef = useRef(layer);
  layerRef.current = layer;
  return useCallback<() => boolean>(() => {
    markGuestCheckoutExposed();
    return layerRef.current.get('is-guest-checkout-enabled', false) === true;
  }, []);
};

export default useIsInGuestCheckoutVariant;
